var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useI18n } from '@cta-portal/webapp-common/lib/hooks/translations/use-i18n';
import React from 'react';
import styled from 'styled-components';
export default function Note() {
    var t = useI18n().t;
    return (_jsx(Container, { children: _jsx("p", { className: "text", children: t('staking.information.note.text') }) }));
}
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: flex-start;\n  background: rgba(204, 167, 104, 0.1);\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 16px;\n  width: 100%;\n\n  & > p {\n    color: ", ";\n    font-size: 14px;\n    margin-bottom: 0 !important;\n  }\n"], ["\n  align-items: flex-start;\n  background: rgba(204, 167, 104, 0.1);\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 16px;\n  width: 100%;\n\n  & > p {\n    color: ", ";\n    font-size: 14px;\n    margin-bottom: 0 !important;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.palette.text;
});
var templateObject_1;
